import React from "react";
import ZIcon from "../ZIcon";
import { EIcons } from "../ZIcon/interface";
import { IFilterChipProps } from "./interface";
import { EIconSizes } from "../ZButton/interface";

const FilterChip: React.FC<IFilterChipProps> = ({
	deletable = false,
	content,
	onDelete,
	className = "",
	cancelIconSize = EIconSizes.small
}) => {
	let newClassName = className;
	if (
		!className.includes("m-") &&
		!className.includes("mr-") &&
		!className.includes("mx-")
	)
		newClassName += " mr-2";
	return !deletable ? (
		<div
			className={`border border-solid border-gray-5 rounded-md bg-gray-3 px-2 py-1 min-h-8 ${newClassName}`}
		>
			{content}
		</div>
	) : (
		<div
			className={`border border-solid border-gray-5 rounded-md bg-gray-3 px-2 py-1 flex min-h-8 items-center justify-between ${newClassName}`}
		>
			{content}
			<ZIcon
				name={EIcons.CANCEL}
				size={cancelIconSize}
				className="ml-2 mr-0 cursor-pointer stroke-current text-gray-6 hover:text-red-4"
				onClick={onDelete}
			/>
		</div>
	);
};

export default FilterChip;
